import React, { useEffect, useState, useCallback } from 'react';
// styles
import useStyles from "./styles";
import { useSelector, useDispatch } from "react-redux";
import { Divider, Paper, AppBar, Tabs, Tab, Typography, Box, InputAdornment, Tooltip, ListItem, ListItemIcon, ListItemText, Grid, Link, TextField, CircularProgress, IconButton, Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Scrollbars } from 'react-custom-scrollbars';
import { getDashletDialogLinks } from "../../../../store/actions/dashboard.actions";
import { FaIcon } from "../../../";
import AddCustomTile from "../AddCustomTile";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}
export default function AddActiveTile({ addDashlet, openAddDashlet, setOpenAddDashlet, webOptions, setWebOptions }) {
    const { isAuthenticated } = useSelector((state) => state.auth);
    const { dashletDialogData, dashletDialogLoading, addDashletLoading, addDashletError } = useSelector((state) => state.dashboard);

    const dispatch = useDispatch();
    const theme = useTheme();

    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyles();
    const [value, setValue] = useState(0);

    const [displayedModules, setDisplayedModules] = useState(null);
    const [displayedWeb, setDisplayedWeb] = useState(null);
    const [webOptionsValue, setWebOptionsValue] = useState(null);
    
    const getDashletDialogData = useCallback(
        () => isAuthenticated && dispatch(getDashletDialogLinks()),
        [dispatch, isAuthenticated],
    );

    useEffect(() => {
        getDashletDialogData()
    }, [])
    useEffect(() => {
        setDisplayedModules(dashletDialogData.modules)
        setDisplayedWeb(dashletDialogData.web)
    }, [dashletDialogData]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChangeWebOptions = (value, key) => {
        setWebOptionsValue({ ...webOptionsValue, [key]: value });
        webOptions[key] = value;
    }
    const handleClickOpen = () => {
        setOpenAddDashlet(true);
    };
    const handleClose = () => {
        setOpenAddDashlet(false);
    };

    const truncate = (input, limit) => input.length > limit ? `${input.substring(0, limit)}...` : input;
    const searchHandler = (event) => {

        let searcjQery = event.target.value.toLowerCase();
        let getdisplayedModules = Object.values(dashletDialogData.modules).filter((el) => {
            let searchValue = el.title.toLowerCase();
            return searchValue.indexOf(searcjQery) !== -1;
        });
        let getdisplayedWeb = Object.values(dashletDialogData.web).filter((el) => {
            let searchValue = el.title.toLowerCase();
            return searchValue.indexOf(searcjQery) !== -1;
        });

        setDisplayedModules(getdisplayedModules)
        setDisplayedWeb(getdisplayedWeb)

    }
    return (
        <div>
            {/* <Link onClick={handleClickOpen}>
                <BarChartIcon />
            </Link> */}
            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                maxWidth="md"
                open={openAddDashlet}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                classes={{ paper: classes.dialogPaper }}
            >
                <DialogTitle className={classes.popupHeaderBorder}>

                    <Typography variant="subtitle1">Add Active Tiles {addDashletLoading ? <CircularProgress size={16} style={{ marginLeft: 5 }} /> : null}</Typography></DialogTitle>

                <DialogContent>
                    <Paper component="form" className={classes.searchRoot}>

                        <TextField
                            placeholder="Search Dashlet"
                            variant="outlined"
                            size="small"
                            onChange={searchHandler}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">
                                    <Tooltip title="Related To">
                                        <IconButton>
                                            <SearchIcon />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>,
                            }}
                        />

                    </Paper>
                    <Scrollbars autoHide={true} style={{ height: "60vh" }}>
                        <div className={classes.root}>
                            <AppBar position="static" color="default">
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                //   variant="fullWidth"
                                // aria-label="full width tabs example"
                                >
                                    <Tab key="Modules" label="Modules" {...a11yProps(0)} />
                                    <Tab key="Web" label="Web" {...a11yProps(1)} />
                                    <Tab key="Custom" label="Custom" {...a11yProps(2)} />
                                </Tabs>
                            </AppBar>


                            <TabPanel key="panelModules" value={value} index={0} dir={theme.direction}>
                                <Grid container spacing={0}>
                                    {dashletDialogLoading ? <CircularProgress /> : displayedModules && Object.keys(displayedModules).map((keyName, i) => (

                                        <Grid className={classes.cstmgridadd} key={"mod" + keyName} item xs={6} sm={3} >
                                            <ListItem key={keyName} onClick={() => addDashlet(displayedModules[keyName].id)}
                                                button className={classes.listitem}>
                                                <ListItemIcon className={classes.listitemicon}>
                                                    <FaIcon icon={`fas ${displayedModules[keyName].icon ? displayedModules[keyName].icon : "fas fa-cube"}`} size="1x" />

                                                </ListItemIcon>

                                                <ListItemText
                                                    // onClick={() => {
                                                    //     alert(displayedModules[keyName].title);
                                                    // }}
                                                    primary={<Link

                                                        className={classes.dashletLink}
                                                        title={displayedModules[keyName].title}
                                                    >{truncate(displayedModules[keyName].title, 15)}</Link>} />
                                            </ListItem>
                                        </Grid>
                                    ))}


                                </Grid>

                            </TabPanel >
                            <TabPanel key="panelWeb" value={value} index={1} dir={theme.direction}>
                                <Grid container spacing={1} >
                                    {dashletDialogLoading ? <CircularProgress /> :
                                        displayedWeb && Object.keys(displayedWeb).map((keyName, i) => (

                                            <Grid key={"web" + keyName} item xs={6}  >
                                                <Paper component="form" className={classes.searchRoot}>
                                                    {/* <InputBase
                                                    className={classes.searchInput}
                                                    placeholder={displayedWeb[keyName].title}

                                                    inputProps={{
                                                        'aria-label': displayedWeb[keyName].title, onChange: (e) => handleChangeWebOptions(e.target.value, displayedWeb[keyName].id),
                                                        name: displayedWeb[keyName].id,
                                                        id: displayedWeb[keyName].id, value: webOptions ? webOptions[displayedWeb[keyName].id] ? webOptions[displayedWeb[keyName].id] : null : null
                                                    }}
                                                /> */}
                                                    <TextField
                                                        placeholder={displayedWeb[keyName].title}
                                                        variant="outlined"
                                                        size="small"
                                                        name={displayedWeb[keyName].id}
                                                        onChange={(e) => handleChangeWebOptions(e.target.value, displayedWeb[keyName].id)}
                                                        value={webOptions ? webOptions[displayedWeb[keyName].id] ? webOptions[displayedWeb[keyName].id] : null : null}
                                                        fullWidth
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <Divider className={classes.searchDivider} orientation="vertical" />
                                                    <Button
                                                        variant="contained"
                                                        disabled={(webOptionsValue && webOptionsValue[displayedWeb[keyName].id]) ? false : true}
                                                        color="primary"
                                                        className={classes.button}
                                                        startIcon={<SaveIcon />}
                                                        onClick={() => { addDashlet(displayedWeb[keyName].id); }}>
                                                        Save
                                                    </Button>
                                                    {/* <IconButton color="primary" className={classes.searchIconButton}
                                                    onClick={() => {addDashlet(displayedWeb[keyName].id);}}

                                                    aria-label="directions">
                                                    <Icon className="fa fa-plus-circle" color="primary"></Icon>
                                                </IconButton> */}
                                                </Paper>

                                            </Grid>

                                        ))}
                                </Grid>

                            </TabPanel>
                            <TabPanel key="panelCustom" value={value} index={2} dir={theme.direction}>
                             <AddCustomTile addDashlet={addDashlet} />
                            </TabPanel>

                        </div>
                    </Scrollbars>
                </DialogContent>

                <DialogActions>
                    <Button className={classes.whitetextcolor} variant="contained" onClick={handleClose} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
